import { useEffect, useState } from 'react';
import { DrivingDistance, Insurance } from '../../@types/codegen/types';
import { gqlQuery } from '../client';
import { PublicApiSettings } from '../config';
import { toInsurances } from './adapter';
import { INSURANCE_INQUIRY_QUERY } from './queries';
import { InsuranceInquiryData } from './types';

/** Legacy enum values → the public API's DrivingDistance. */
const DRIVING_DISTANCE: Record<DrivingDistance, string> = {
  [DrivingDistance.Between0And1000]: 'BETWEEN_0_AND_1000',
  [DrivingDistance.Between1000And1500]: 'BETWEEN_1000_AND_1500',
  [DrivingDistance.Between1500And2000]: 'BETWEEN_1500_AND_2000',
  [DrivingDistance.Between2000And2500]: 'BETWEEN_2000_AND_2500',
  [DrivingDistance.Over2500]: 'OVER_2500',
};

/** Insurance quotes through iteration.commerce.insuranceInquiry. */
const useInsuranceInquiry = (
  publicApi: PublicApiSettings | undefined,
  adId: string,
  personalNumber?: string,
  drivingDistance?: DrivingDistance
) => {
  const [insurances, setInsurances] = useState<Insurance[]>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const skip = !publicApi || !personalNumber || !drivingDistance;

  useEffect(() => {
    if (skip) return;
    let active = true;
    setLoading(true);
    setError(false);
    gqlQuery<InsuranceInquiryData>(publicApi.api, INSURANCE_INQUIRY_QUERY, {
      id: adId,
      socialId: personalNumber,
      drivingDistance: DRIVING_DISTANCE[drivingDistance],
    })
      .then((data) => {
        const list = data.ads?.byAdId?.iteration?.commerce.insuranceInquiry?.insurances || [];
        if (active) setInsurances(toInsurances(list));
      })
      .catch(() => active && setError(true))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [skip, adId, personalNumber, drivingDistance]);

  return { loading, error, insurances };
};

export default useInsuranceInquiry;
